<template>
  <transition name="fade">
    <div v-if="!online" class="network-status-offline">
      <el-alert
        :title="offlineTitle"
        type="warning"
        :closable="false"
        show-icon
      >
        <template #default>
          <span>{{ offlineMessage }}</span>
        </template>
      </el-alert>
    </div>
  </transition>
  
  <transition name="fade">
    <div v-if="online && showOnlineMessage" class="network-status-online">
      <el-alert
        title="网络已恢复"
        type="success"
        :closable="true"
        @close="showOnlineMessage = false"
        show-icon
      />
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useNetwork } from '@/composables/useNetwork'

const { online } = useNetwork()
const showOnlineMessage = ref(false)

const offlineTitle = '网络连接已断开'
const offlineMessage = '您当前处于离线状态，应用将使用缓存数据。部分功能可能无法正常使用。'

// 监听网络恢复
const handleOnline = () => {
  showOnlineMessage.value = true
  // 3秒后自动隐藏
  setTimeout(() => {
    showOnlineMessage.value = false
  }, 3000)
}

onMounted(() => {
  window.addEventListener('network-online', handleOnline)
})

onUnmounted(() => {
  window.removeEventListener('network-online', handleOnline)
})
</script>

<style scoped>
.network-status-offline {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 12px;
}

.network-status-online {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9998;
  min-width: 300px;
  max-width: 400px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>

